// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCompare: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="currentColor">
            <path
                fill="#999"
                d="M390.625,1210.375 L396.873047,1210.375 L396.874592,1211.78125 C396.874592,1211.96771 396.984982,1212.13652 397.156037,1212.21094 C397.327014,1212.28539 397.525764,1212.25152 397.662482,1212.12488 L399.849982,1210.09363 C400.049982,1209.90809 400.049982,1209.59187 399.849982,1209.40633 L397.662482,1207.37508 C397.52592,1207.24844 397.32713,1207.21459 397.156037,1207.28898 C396.984982,1207.36352 396.874592,1207.53234 396.874592,1207.71867 L396.873047,1209.125 L390.625,1209.125 C390.279492,1209.125 390,1209.4043 390,1209.73242 C390,1210.06055 390.279492,1210.375 390.625,1210.375 Z M399.375,1214.125 L393.126953,1214.125 L393.125,1212.70117 C393.125,1212.51471 393.01461,1212.3459 392.843555,1212.27148 C392.673828,1212.21484 392.474609,1212.24805 392.337891,1212.375 L390.150391,1214.40625 C389.95039,1214.5918 389.95039,1214.90801 390.150391,1215.09355 L392.337891,1217.1248 C392.474453,1217.25144 392.673242,1217.28533 392.844336,1217.21086 C393.015625,1217.13672 393.125,1216.9668 393.125,1216.78125 L393.126954,1215.375 L399.375,1215.375 C399.720508,1215.375 400,1215.09551 400,1214.75 C400,1214.40449 399.720704,1214.125 399.375,1214.125 L399.375,1214.125 Z"
                transform="translate(-390 -1207)"
            />
        </svg>
    );
};

export default React.memo(IconCompare);
